import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTABar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 800px
      setIsVisible(window.scrollY > 800);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-134">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-2xl" data-id="element-135">
          <div className="max-w-5xl mx-auto px-4 py-3 flex items-center gap-4" data-id="element-136">
            {/* Product thumbnail */}
            <img src="https://images.unsplash.com/photo-1611652022419-a9419f74343d?w=200&q=80" alt="Chime" className="w-12 h-12 rounded-lg object-cover flex-shrink-0 hidden sm:block" data-id="element-137" />

            {/* Product info */}
            <div className="flex-1 min-w-0" data-id="element-138">
              <p className="font-semibold text-sm text-gray-900" data-id="element-139">
                Chime Breathing Necklace
              </p>
              <p className="text-xs text-gray-600" data-id="element-140">$40 · 30-day guarantee</p>
            </div>

            {/* CTA */}
            <a href="#" className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg font-semibold text-sm transition-colors whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-141">
              Shop Now
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}